import {
  DefaultButton,
  Panel,
  PanelType,
  PrimaryButton,
  DetailsList,
  SelectionMode,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { InviteeForm } from './inviteePanel/InviteeForm';

const InviteePanel = ({
  isPanelOpen,
  onPanelClose,
  cprValue,
  setCprValue,
  cvrValue,
  setCvrValue,
  emailValue,
  setEmailValue,
  keys,
  onAddKey,
  onRemoveKey,
  onSaveChanges,
  showGroupName = false,
  groupName = null,
  getColumns,
  isUpdating,
}) => {
  const { t: translator } = useTranslation();

  return (
    <Panel
      isOpen={isPanelOpen}
      type={PanelType.medium}
      onDismiss={onPanelClose}
      isLightDismiss={true}
      closeButtonAriaLabel={translator('ariaLabel.panelClose')}
      className="inviteePanel"
    >
      <div className="panel-content">
        <h3 className="panel-header">
          {translator('components.inviteeForm.header')}
        </h3>

        {showGroupName && groupName && (
          <p>
            {translator('components.inviteeForm.groupName')}: {groupName}
          </p>
        )}

        <InviteeForm
          cprValue={cprValue}
          setCprValue={setCprValue}
          cvrValue={cvrValue}
          setCvrValue={setCvrValue}
          emailValue={emailValue}
          setEmailValue={setEmailValue}
          onAddKey={onAddKey}
        />

        <div className="panel-content">
          <p>
            {translator('components.inviteeForm.currentKeys')}: ({keys.length})
          </p>

          {keys.length > 0 ? (
            <DetailsList
              items={keys}
              columns={getColumns(translator, onRemoveKey)}
              selectionMode={SelectionMode.none}
              compact={true}
              isHeaderVisible={true}
            />
          ) : (
            <p className="grey italic">
              {translator('components.inviteeForm.noKeys')}
            </p>
          )}
        </div>

        <div className="panel-buttons">
          {isUpdating && <Spinner size={SpinnerSize.large} />}
          <DefaultButton
            text={translator('global.cancel')}
            onClick={onPanelClose}
            disabled={isUpdating}
          />
          <PrimaryButton
            text={translator('global.save')}
            onClick={onSaveChanges}
            disabled={isUpdating}
          />
        </div>
      </div>
    </Panel>
  );
};

export { InviteePanel };
